import React, { Fragment } from "react";
import classes from "./Shortcut.module.css";
const Shortcut = (props) => {
  const { keys, label, onClick = () => {}, style } = props;
  return (
    <div className={classes["shortcut"]} style={style}>
      {keys.map((k, index) => {
        return (
          <Fragment key={label + "_" + index}>
            {typeof k === "string" && (
              <div
                className={`${classes["shortcut-key"]} ${
                  index !== keys.length - 1 ? classes["margin-right"] : ""
                }`}
                onClick={onClick}
              >
                <div className={classes["shortcut-key-container"]}>
                  <div className={classes["shortcut-key-content"]}>{k}</div>
                </div>
              </div>
            )}
            {typeof k === "object" && <img src={k.image} alt="shortcut" />}
          </Fragment>
        );
      })}
      {label && <div className={classes["shortcut-label"]}>{label}</div>}
    </div>
  );
};

export default Shortcut;
